import {
  CLEAR_SEGMENT_CHANGE_HISTORY_SUCCESS,
  GET_SEGMENT_CHANGE_HISTORY_FAILURE,
  GET_SEGMENT_CHANGE_HISTORY_REQUEST,
  GET_SEGMENT_CHANGE_HISTORY_SUCCESS,
  SegmentChangeHistoryActionTypes,
  SegmentChangeHistoryState,
} from './segmentChangeHistory.types';

const initialState: SegmentChangeHistoryState = {
  changeHistory: [],
  loading: false,
  error: null,
  success: false,
};

const segmentChangeHistoryReducer = (
  state = initialState,
  action: SegmentChangeHistoryActionTypes
): SegmentChangeHistoryState => {
  switch (action.type) {
    case GET_SEGMENT_CHANGE_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case GET_SEGMENT_CHANGE_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        changeHistory: action.payload.activity,
      };

    case GET_SEGMENT_CHANGE_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
        changeHistory: [],
      };

    case CLEAR_SEGMENT_CHANGE_HISTORY_SUCCESS:
      return {
        ...state,
        success: false,
      };

    default:
      return state;
  }
};

export default segmentChangeHistoryReducer;
